const mcw = 1200; // Please change the var in index.css and check that the values are equal!
const pmPad = 65;

export enum EStylings {
  FORM_ELEMENT_HEIGHT = 56 /* 3rem in px */,
  PAGE_MODULE_PAD = pmPad * 2,
  MIN_CONTENT_WIDTH = mcw,
  MAX_PAGE_MODULE_WIDTH = mcw + pmPad * 2
}
